<template>
<div>
  <banner :title="stackError" :active.sync="showBanner"  :error="!!stackError" />
  <sidebar-modal
    :active.sync="showPanel"
    :title="sidebarTitle"
    :button="sidebarButton"
    :loading="sidebarLoading"
    :message.sync="sidebarMessage"
    :error.sync="sidebarError"
    v-on:action="sidebarAction"
    >
    <component :is="sidebarComponent" />
  </sidebar-modal>
  <div class="content-wrapper">
    <div class="flexcolumns">
      <margin-title :title="$t('wallet.title')" :amount="balance" />
<!--      <button class="button is-primary" @click="toggleTransferToken">-->
<!--        SEND-->
<!--      </button>-->
    </div>
    <div class="is-flex space-between">
      <wallet-nav class="wallet-nav" :active="activeWalletNav" v-on:active="onActiveWalletNav" />
    </div>
    <transaction-list v-on:showSidebar="toggleTransactionDetailPanel" />
<!--    <paging-controls v-if="transactions.length > 0" class="m-t-24" />-->
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import MarginTitle from '../components/hvt-margin-title'
import WalletNav from '@/components/wallet/nav'
import TransactionList from '@/components/wallet/transaction-list'
import Modal from '@/components/dropdown-modal'
import SidebarModal from '@/components/sidebar-modal'
import TransactionDetails from '@/components/wallet/transaction-details'
import PrototypeInfo from '@/components/prototype/prototype-info'
import SendToken from '@/components/wallet/send'
import PagingControls from '@/components/wallet/paging-controls'
import Banner from '@/components/general/banner'

export default {
  name: 'wallet',
  components: {
    MarginTitle,
    WalletNav,
    TransactionList,
    TransactionDetails,
    Modal,
    SidebarModal,
    PrototypeInfo,
    SendToken,
    PagingControls,
    Banner
  },
  data () {
    return {
      activeWalletNav: 'all',
      isActive: false,
      showPanel: false,
      transaction: null,
      sidebarTitle: '',
      sidebarComponent: null,
      sidebarButton: null,
      sidebarType: null,
      sidebarLoading: false,
      sidebarMessage: null,
      sidebarError: null
    }
  },
  computed: {
    ...mapState('walletTx', ['transactions']),
    ...mapGetters('app', [
      'walletModalViewed'
    ]),
    ...mapGetters('jobs', [
      'currentJob'
    ]),
    ...mapGetters('wallet', [
      'getActiveTokenBalance'
    ]),
    ...mapState('wallet', ['linkedAccount', 'send', 'error']),
    ...mapState('wallet', {
      stackError: 'error'
    }),
    ...mapState('sigproviders', ['defaultProvier', 'lastTx', 'error']),
    showBanner: {
      get () {
        return this.stackError || false
      },
      set () {
        this.setError(null)
      }
    },
    balance () {
      return this.getActiveTokenBalance ? this.getActiveTokenBalance.balance : 0
    }
  },
  watch: {
    lastTx: {
      deep: true,
      handler: function (newValue) {
        if (newValue !== null && newValue.transaction_id) {
          this.sidebarMessage = this.$t('wallet.transferSucess')
        }
      }
    },
    error (newValue) {
      if (newValue) {
        this.sidebarError = newValue
      }
    }
  },
  methods: {
    onActiveWalletNav (newValue) {
      this.activeWalletNav = newValue
    },
    ...mapMutations('app', [
      'setWalletModalViewed'
    ]),
    ...mapMutations('wallet', ['setError']),
    async sidebarAction () {
      try {
        switch (this.sidebarType) {
          case 'TRANSFER_TOKEN':
            this.sidebarLoading = true
            await this.initProviders()
            await this.connectWallet(this.defaultProvier)
            await this.transfer(this.send)
            this.sidebarLoading = false
            break
        }
      } catch (error) {
        this.sidebarLoading = false
      }
    },
    toggleTransferToken () {
      this.sidebarLoading = false
      this.sidebarComponent = 'SendToken'
      this.showPanel = true
      this.sidebarTitle = 'Transfer Token'
      this.sidebarButton = 'Transfer'
      this.sidebarType = 'TRANSFER_TOKEN'
    },
    toggleTransactionDetailPanel (transaction) {
      this.$store.dispatch('walletTx/setCurrentTx', transaction)
      this.sidebarComponent = 'TransactionDetails'
      this.sidebarTitle = 'Transaction Detail'
      this.showPanel = true
    },
    ...mapActions('jobs', [
      'getJob'
    ]),
    ...mapMutations('jobs', [
      'resetJobs'
    ]),
    ...mapActions('sigproviders', ['transfer', 'initProviders', 'connectWallet']),
    ...mapActions('walletTx', [
      'fetch'
    ]),
    close () {
      this.isActive = false
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>

.image {
  margin: 0;
}

.flexcolumns {
  display: flex;
  justify-content: space-between;
}

.button {
  min-width: 96px;
  min-height: 40px;
}

.heading {
  margin-bottom: 0;
}

.list-nav.wallet-nav {
  margin-bottom: 2.5rem;
}

</style>



// WEBPACK FOOTER //
// src/pages/wallet.vue